import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export const generateFixedDepositAnalysisAuditExcel = async (reportData, selectedDate, endDate) => {
  if (!reportData || !reportData.length) return;

  const safeEndDate = endDate || new Date().toISOString().slice(0, 10);

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("FD Analysis Report", {
    views: [{ state: "frozen", ySplit: 4, xSplit: 1 }],
  });

  const totalBranches = reportData.length;
  const columnsPerBranch = 5;

  const totalColumns = 1 + totalBranches * columnsPerBranch;

  worksheet.mergeCells(1, 1, 1, totalColumns);
  const titleCell = worksheet.getCell(1, 1);
  titleCell.value = `Fixed Deposit Account Analysis Report  ${safeEndDate}`;
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleCell.font = { bold: true, size: 14 };

  const rowHeaders = [
    safeEndDate.replace(/-/g, "/"),
    "As of the 30th day of the month preceding",
    "As of the audit date",
  ];

  let currentColumn = 2;
  reportData.forEach((branch) => {
    const branchStart = currentColumn;
    const branchEnd = currentColumn + columnsPerBranch - 1;

    worksheet.mergeCells(3, branchStart, 3, branchEnd);
    const branchCell = worksheet.getCell(3, branchStart);
    branchCell.value = branch.branchName;
    branchCell.font = { bold: true };
    branchCell.alignment = { horizontal: "center", vertical: "middle" };

    for (let col = branchStart; col <= branchEnd; col++) {
      const cell = worksheet.getCell(3, col);
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    }

    currentColumn += columnsPerBranch;
  });

  const depositTypesHeaderCell = worksheet.getCell(4, 1);
  depositTypesHeaderCell.value = "Deposit types";
  depositTypesHeaderCell.font = { bold: true };
  depositTypesHeaderCell.alignment = { horizontal: "center", vertical: "middle" };
  depositTypesHeaderCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

  const branchHeaders = ["Member", "Rate %", "Non-member", "Rate %", "Collection"];
  currentColumn = 2;
  reportData.forEach(() => {
    branchHeaders.forEach((header, idx) => {
      const cell = worksheet.getCell(4, currentColumn + idx);
      cell.value = header;
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
    });
    currentColumn += columnsPerBranch;
  });

  rowHeaders.forEach((label, rowIndex) => {
    const actualRow = 5 + rowIndex;
    const labelCell = worksheet.getCell(actualRow, 1);
    labelCell.value = label;
    labelCell.alignment = { horizontal: "left", vertical: "middle" };
    labelCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };

    currentColumn = 2;
    reportData.forEach((branch) => {
      for (let i = 0; i < columnsPerBranch; i++) {
        const cell = worksheet.getCell(actualRow, currentColumn + i);
        cell.value = rowIndex === 0 && i === 0 ? branch.totalFixedDepositAccounts : "";
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
      }
      currentColumn += columnsPerBranch;
    });
  });

  worksheet.getColumn(1).width = 35;
  currentColumn = 2;
  reportData.forEach(() => {
    worksheet.getColumn(currentColumn).width = 12;
    worksheet.getColumn(currentColumn + 1).width = 10;
    worksheet.getColumn(currentColumn + 2).width = 13;
    worksheet.getColumn(currentColumn + 3).width = 10;
    worksheet.getColumn(currentColumn + 4).width = 12;
    currentColumn += columnsPerBranch;
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `Fixed_Deposit_Analysis_${safeEndDate.replace(/-/g, "_")}.xlsx`);
};
